var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var MinusIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50.09,
    glyphHeight: 8.35
  }), React.createElement("path", {
    d: "M50.5485 0.825623H0.461548V9.17345H50.5485V0.825623Z",
    fill: "black"
  }));
};
export var MinusIconGlyph = function (props) {
  return React.createElement(MinusIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};